import { VpnMessage, VpnMessageType } from '@playcastdotio/Messaging';
import { vpnInfoState } from '../../../stores/shared';

export const handleVpnMessage = (message: VpnMessage) => {
  switch (message.type) {
    case VpnMessageType.VPN_CONNECT_RESPONSE: {
      console.log('[VPN] Received VPN server assignment:', message.hostname, 'region:', message.region, 'overflowed:', message.overflowed);
      vpnInfoState.updateState({
        ...vpnInfoState.currentState,
        vpnHostname: message.hostname,
      });
      break;
    }

    case VpnMessageType.VPN_ERROR: {
      console.error('[VPN] Error from realtime API:', message.error);
      break;
    }

    // Requests are client-initiated only; ignore here if received
    case VpnMessageType.VPN_CONNECT_REQUEST: {
      console.warn('[VPN] Unexpected VPN_CONNECT_REQUEST received on client');
      break;
    }
  }
};


